/** Reading an event's payload, which is any JSON. */

export function field(payload: unknown, name: string): unknown {
    return payload && typeof payload === "object"
        ? (payload as Record<string, unknown>)[name]
        : undefined;
}

export function text(payload: unknown, name: string): string | null {
    const value = field(payload, name);
    return typeof value === "string" && value !== "" ? value : null;
}

export function count(payload: unknown, name: string): number | null {
    const value = field(payload, name);
    return typeof value === "number" ? value : null;
}
